import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Copy, Plus, Trash2, Save } from "lucide-react";

export default function CopyLibrary() {
  const [blocks, setBlocks] = useState([]);
  const [draft, setDraft] = useState({ key: "", title: "", body: "", category: "General" });
  const [show, setShow] = useState(false);

  const load = () => api.copy().then(setBlocks);
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!draft.title || !draft.body) { toast.error("Title and body required"); return; }
    await api.createCopy({ ...draft, key: draft.key || draft.title.toLowerCase().replace(/\s+/g, "_") });
    toast.success("Saved"); setDraft({ key: "", title: "", body: "", category: "General" }); setShow(false); load();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div><div className="eyebrow text-[#D4AF37]">Approved language</div><h1 className="font-display text-3xl sm:text-4xl mt-1">Copy Library</h1></div>
        <button data-testid="add-copy-btn" onClick={() => setShow((s) => !s)} className="gold-btn px-4 py-2.5 rounded-lg text-sm inline-flex items-center gap-2"><Plus className="w-4 h-4" /> New block</button>
      </div>

      {show && (
        <div className="card-lux p-5 space-y-3" data-testid="copy-form">
          <div className="grid sm:grid-cols-2 gap-3">
            <input placeholder="Title" value={draft.title} onChange={(e) => setDraft({ ...draft, title: e.target.value })} className="px-3 py-2.5 rounded-lg bg-[#0A0C10] border border-[#2A3042] text-sm outline-none focus:border-[#D4AF37]" />
            <input placeholder="Category" value={draft.category} onChange={(e) => setDraft({ ...draft, category: e.target.value })} className="px-3 py-2.5 rounded-lg bg-[#0A0C10] border border-[#2A3042] text-sm outline-none focus:border-[#D4AF37]" />
          </div>
          <textarea placeholder="Body" rows={3} value={draft.body} onChange={(e) => setDraft({ ...draft, body: e.target.value })} className="w-full px-3 py-2.5 rounded-lg bg-[#0A0C10] border border-[#2A3042] text-sm outline-none focus:border-[#D4AF37]" />
          <button onClick={add} className="gold-btn px-4 py-2 rounded-lg text-sm inline-flex items-center gap-2"><Save className="w-4 h-4" /> Save</button>
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {blocks.map((b) => (
          <div key={b.id} className="card-lux p-5" data-testid={`copy-${b.id}`}>
            <div className="flex items-center justify-between mb-1">
              <div className="text-[#F8FAFC] font-medium">{b.title}</div>
              <span className="text-[10px] px-2 py-0.5 rounded bg-[#222736] text-[#94A3B8]">{b.category}</span>
            </div>
            <p className="text-sm text-[#94A3B8] leading-relaxed whitespace-pre-wrap">{b.body}</p>
            <div className="flex gap-2 mt-3">
              <button onClick={() => { navigator.clipboard.writeText(b.body); toast.success("Copied"); }} className="text-xs px-3 py-1.5 rounded-md border border-[#2A3042] text-[#94A3B8] hover:text-[#F3E5AB] inline-flex items-center gap-1"><Copy className="w-3 h-3" /> Copy</button>
              <button onClick={() => api.delCopy(b.id).then(load)} className="text-xs px-3 py-1.5 rounded-md border border-[#2A3042] text-[#64748B] hover:text-[#EF4444] inline-flex items-center gap-1"><Trash2 className="w-3 h-3" /> Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
